import {useEffect, useState} from "react";

export function TreeCheckboxes  ({treeData, data, onChange, availablePermissions}) {
    const [expandedCategories, setExpandedCategories] = useState({});
    const [expandedSecondChildren, setExpandedSecondChildren] = useState({});
    const [expandedThirdChildren, setExpandedThirdChildren] = useState({});
    const [dataCheck, setDataCheck] = useState(null);
    const [checkTree, setCheckTree] = useState(true);

    useEffect(() => {
        setDataCheck(data);
        setTimeout(() => {         
            setCheckTree(false);
        }, 500);     
    }, []);

    const isAvailable = (perm) => {
        if (availablePermissions === undefined) {
            return true;
        }
        if (availablePermissions === null || availablePermissions.length === 0) {
            return false;
        }
        return availablePermissions.some(availablePerm => {
            if (perm === availablePerm) return true;
            if (perm.startsWith(availablePerm + '.')) return true;
            if (availablePerm.startsWith(perm + '.')) return true;
            return false;
        });
    };

    const getEffectivePermissions = (perm) => {
        if (availablePermissions === undefined) return [perm];
        if (!availablePermissions || availablePermissions.length === 0) return [];
        if (availablePermissions.includes(perm)) return [perm];
        if (availablePermissions.some(ap => perm.startsWith(ap + '.'))) return [perm];
        const children = availablePermissions.filter(p => p.startsWith(perm + '.'));
        return children;
    };

    const isEffectivelyChecked = (perm) => {
        if (!dataCheck) return false;
        if (dataCheck.includes(perm)) return true;
        if (dataCheck.some(d => perm.startsWith(d + '.'))) return true;
        const effective = getEffectivePermissions(perm);
        if (effective.length === 0) return false;
        return effective.every(p =>
            dataCheck.includes(p) || dataCheck.some(d => p.startsWith(d + '.'))
        );
    };
    
    useEffect(() => {
        if (data) {
            const resultArray = data.map(value => {
                if (value?.includes('.')) {
                    return value?.split('.')[0];
                }
            });
            const filteredArray = resultArray.filter(item => item !== undefined);

            if (filteredArray && filteredArray.length > 0) {
                const newExpandedCategories = filteredArray.reduce((acc, category) => {
                    if (acc[category] === undefined) {
                        acc[category] = true;
                    }
                    return acc;
                }, { ...expandedCategories });
                setExpandedCategories(newExpandedCategories);
            }

            const resultArrayChild = data.map(value => {
                if (value?.split('.').length - 1 >= 2) {
                    return value?.split('.').slice(0, 2).join('.');
                }
            });
            const filteredArrayChild = resultArrayChild.filter(item => item !== undefined);

            if (filteredArrayChild && filteredArrayChild.length > 0) {
                const newExpandedSecondChildren = filteredArrayChild.reduce((acc, category) => {
                    if (acc[category] === undefined) {
                        acc[category] = true;
                    }
                    return acc;
                }, { ...expandedSecondChildren });
                setExpandedSecondChildren(newExpandedSecondChildren);
            }

            const resultArrayThirdChild = data.map(value => {
                if (value?.split('.').length - 1 >= 3) {
                    return value?.split('.').slice(0, 3).join('.');
                }
            });
            const filteredArrayThirdChild = resultArrayThirdChild.filter(item => item !== undefined);

            if (filteredArrayThirdChild && filteredArrayThirdChild.length > 0) {
                const newExpandedThirdChildren = filteredArrayThirdChild.reduce((acc, category) => {
                    if (acc[category] === undefined) {
                        acc[category] = true;
                    }
                    return acc;
                }, { ...expandedThirdChildren });
                setExpandedThirdChildren(newExpandedThirdChildren);
            }
        }
    }, [dataCheck]);

    const toggleCategory = (category) => {
        setExpandedCategories({
            ...expandedCategories,
            [category]: !expandedCategories[category]
        });
    };
    const toggleSecondChildren = (child) => {
        setExpandedSecondChildren({
            ...expandedSecondChildren,
            [child]: !expandedSecondChildren[child]
        });
    };
    const toggleThirdChildren = (child) => {
        setExpandedThirdChildren({
            ...expandedThirdChildren,
            [child]: !expandedThirdChildren[child]
        });
    };

    const handleParentChange = (category) => {
        const effective = getEffectivePermissions(category);
        if (effective.length === 0) return;

        const currentlyChecked = isEffectivelyChecked(category);

        if (dataCheck) {
            if (currentlyChecked) {
                setDataCheck(prevData =>
                    prevData.filter(perm => perm !== category && !perm.startsWith(category + '.'))
                );
            } else {
                const cleaned = dataCheck.filter(perm =>
                    perm !== category && !perm.startsWith(category + '.')
                );
                const updated = Array.from(new Set([...cleaned, ...effective]));
                setDataCheck(updated);
            }
        } else {
            setDataCheck(effective);
        }
    };

    const handleChildChange = (perm) => {
        const level0 = perm.split('.')[0];
        const level1 = perm.split('.').slice(0, 2).join('.');
        const siblings = treeData.permissions.filter(p => p.startsWith(level0 + '.'));
        const siblings2 = treeData.permissions.filter(p => p.startsWith(level1 + '.'));
        const effective = getEffectivePermissions(perm);

        let finalCheck = null;

        if (dataCheck) {
            if (dataCheck.includes(level0)) {
                const newDataCheck = dataCheck.filter(item => item !== level0);
                if (siblings2.length > 0) {
                    const cleanSiblingChildren = Array.from(
                        new Set(siblings.map(child => child.split('.').slice(0, 2).join('.')))
                    );
                    const filterLevel1 = cleanSiblingChildren.filter(p => p !== level1);
                    const newDataCheck1 = [...newDataCheck, ...filterLevel1];
                    setDataCheck(newDataCheck1);
                    finalCheck = newDataCheck1;
                } else {
                    const updatedDataCheck = [...newDataCheck, ...siblings.filter(sibling => sibling !== perm)];
                    const cleanSiblingChildren = Array.from(
                        new Set(updatedDataCheck.map(child => child.split('.').slice(0, 2).join('.')))
                    );
                    const filterLevel1 = cleanSiblingChildren.filter(p => !p.startsWith(level1 + '.'));
                    const newDataCheck1 = [...filterLevel1];
                    setDataCheck(newDataCheck1);
                    finalCheck = newDataCheck1;
                }
            } else {
                if (dataCheck.includes(perm)) {
                    const cleanDataCheck = dataCheck.filter(p => !p.startsWith(level1 + '.'));
                    const newDataCheck = cleanDataCheck.filter(item => item !== perm);
                    setDataCheck(newDataCheck);
                    finalCheck = newDataCheck;
                } else {
                    const cleanDataCheck = dataCheck.filter(p => !p.startsWith(level1 + '.'));
                    let newDataCheck = [...cleanDataCheck, ...effective];

                    const cleanDataCheck2 = newDataCheck.filter(p => p.startsWith(level0 + '.'));
                    const cleanSiblingChildren = Array.from(
                        new Set(siblings.map(child => child.split('.').slice(0, 2).join('.')))
                    );

                    if (cleanSiblingChildren.length === cleanDataCheck2.length && cleanSiblingChildren.sort().every((item, index) => item === cleanDataCheck2.sort()[index])) {
                        const cleanDataCheck3 = newDataCheck.filter(p => !p.startsWith(level0 + '.'));
                        const parentEffective = getEffectivePermissions(level0);
                        if (parentEffective.length === 1 && parentEffective[0] === level0) {
                            newDataCheck = [...cleanDataCheck3, level0];
                        } else {
                            newDataCheck = [...cleanDataCheck3, ...parentEffective];
                        }
                    }
                    setDataCheck(newDataCheck);
                    finalCheck = newDataCheck;
                }
            }
        } else {
            setDataCheck(effective);
            finalCheck = effective;
        }

        if (finalCheck != null) {
            const allElementsExist = siblings.every(element => finalCheck.includes(element));
            if (allElementsExist) {
                const parent = siblings[0]?.split('.')[0];
                const updateDataCheck = finalCheck.map(item => siblings.includes(item) ? parent : item);
                const FinalData = Array.from(new Set(updateDataCheck));
                setDataCheck(FinalData);
            }
        }
    };

    const handleThirdChildChange = (perm) => {
        const level0 = perm.split('.')[0];
        const level1 = perm.split('.').slice(0, 2).join('.');
        const siblings = treeData.permissions.filter(p => p.startsWith(level1 + '.'));
        const effective = getEffectivePermissions(perm);
        let finalCheck = null;

        if (dataCheck) {
            if (dataCheck.includes(level1)) {
                const newDataCheck = dataCheck.filter(item => item !== level1);
                const updatedDataCheck = [...newDataCheck, ...siblings.filter(sibling => sibling !== perm)];
                setDataCheck(updatedDataCheck);
                finalCheck = updatedDataCheck;
            } else {
                if(dataCheck.includes(perm)) {
                    const newDataCheck = dataCheck.filter(item => item !== perm);
                    setDataCheck(newDataCheck);
                    finalCheck = newDataCheck;
                } else {
                    if (dataCheck.includes(level0)){
                        const newDataCheck = dataCheck.filter(item => item !== level0);
                        const siblingsChildren = treeData.permissions.filter(p => p.startsWith(level0 + '.'));
                        const cleanSiblingChildren = Array.from(
                            new Set(siblingsChildren.map(child => child.split('.').slice(0, 2).join('.')))
                        );
                        const filterLevel1 = cleanSiblingChildren.filter(p => p !== level1);
                        const addThirdPermission = siblings.filter(p => p !== perm);
                        const newDataCheck1 = [...newDataCheck, ...filterLevel1, ...addThirdPermission];
                        setDataCheck(newDataCheck1);
                        finalCheck = newDataCheck1;
                    } else {
                        let newDataCheck = [...dataCheck.filter(p => !p.startsWith(perm + '.')), ...effective];

                        const cleanDataCheck = newDataCheck.filter(p => p.startsWith(level0 + '.'));
                        if (siblings.every(item => cleanDataCheck.includes(item))) {
                            const newCleanDataCheck = newDataCheck.filter(p => !p.startsWith(level1 + '.'));
                            const newDataCheck2 = [...newCleanDataCheck, level1];
                            newDataCheck = newDataCheck2;
                        }

                        const cleanDataCheck2 = newDataCheck.filter(p => p.startsWith(level0 + '.'));
                        const siblingsLevel0 = treeData.permissions.filter(p => p.startsWith(level0 + '.'));
                        const cleanSiblingChildren = Array.from(
                            new Set(siblingsLevel0.map(child => child.split('.').slice(0, 2).join('.')))
                        );

                        if (cleanSiblingChildren.length === cleanDataCheck2.length && cleanSiblingChildren.sort().every((item, index) => item === cleanDataCheck2.sort()[index])) {
                            const cleanDataCheck3 = newDataCheck.filter(p => !p.startsWith(level0 + '.'));
                            const newDataCheck3 = [...cleanDataCheck3, level0];
                            newDataCheck = newDataCheck3;
                        }
                        setDataCheck(newDataCheck);
                        finalCheck = newDataCheck;
                    }
                }
            }
        } else {
            setDataCheck(effective);
            finalCheck = effective;
        }

        if (finalCheck != null) {
            const allElementsExist = siblings.every(element => finalCheck.includes(element));
            if (allElementsExist) {
                const parent = siblings[0].split('.').slice(0, 2).join('.');
                const updateDataCheck = finalCheck.map(item => siblings.includes(item) ? parent : item);
                const FinalData = Array.from(new Set(updateDataCheck));
                setDataCheck(FinalData);
            }
        }
    };

    const handleFourthChildChange = (perm) => {
        const level0 = perm.split('.')[0];
        const level1 = perm.split('.').slice(0, 2).join('.');
        const level2 = perm.split('.').slice(0, 3).join('.');
        const siblings = treeData.permissions.filter(p => p.startsWith(level2 + '.') && p.split('.').length > 3);
        const effective = getEffectivePermissions(perm);
        let finalCheck = null;

        if (dataCheck) {
            if (dataCheck.includes(level2)) {
                const newDataCheck = dataCheck.filter(item => item !== level2);
                const updatedDataCheck = [...newDataCheck, ...siblings.filter(sibling => sibling !== perm)];
                setDataCheck(updatedDataCheck);
                finalCheck = updatedDataCheck;
            } else if (dataCheck.includes(level1)) {
                const newDataCheck = dataCheck.filter(item => item !== level1);
                const siblingsL1 = treeData.permissions.filter(p => p.startsWith(level1 + '.'));
                const cleanL2Siblings = Array.from(new Set(siblingsL1.map(child => child.split('.').slice(0, 3).join('.'))));
                const filterLevel2 = cleanL2Siblings.filter(p => p !== level2);
                const addFourth = siblings.filter(p => p !== perm);
                const newDataCheck1 = [...newDataCheck, ...filterLevel2, ...addFourth];
                setDataCheck(newDataCheck1);
                finalCheck = newDataCheck1;
            } else if (dataCheck.includes(level0)) {
                const newDataCheck = dataCheck.filter(item => item !== level0);
                const siblingsL0 = treeData.permissions.filter(p => p.startsWith(level0 + '.'));
                const cleanL1Siblings = Array.from(new Set(siblingsL0.map(child => child.split('.').slice(0, 2).join('.'))));
                const filterLevel1 = cleanL1Siblings.filter(p => p !== level1);

                const siblingsL1 = treeData.permissions.filter(p => p.startsWith(level1 + '.'));
                const cleanL2Siblings = Array.from(new Set(siblingsL1.map(child => child.split('.').slice(0, 3).join('.'))));
                const filterLevel2 = cleanL2Siblings.filter(p => p !== level2);

                const addFourth = siblings.filter(p => p !== perm);
                const newDataCheck1 = [...newDataCheck, ...filterLevel1, ...filterLevel2, ...addFourth];
                setDataCheck(newDataCheck1);
                finalCheck = newDataCheck1;
            } else {
                if (dataCheck.includes(perm)) {
                    const newDataCheck = dataCheck.filter(item => item !== perm);
                    setDataCheck(newDataCheck);
                    finalCheck = newDataCheck;
                } else {
                    let newDataCheck = [...dataCheck, ...effective];

                    const cleanDataCheckL2 = newDataCheck.filter(p => p.startsWith(level2 + '.'));
                    if (siblings.length === cleanDataCheckL2.length && siblings.every(item => cleanDataCheckL2.includes(item))) {
                        const newCleanDataCheck = newDataCheck.filter(p => !p.startsWith(level2 + '.'));
                        newDataCheck = [...newCleanDataCheck, level2];
                    }

                    const cleanDataCheckL1 = newDataCheck.filter(p => p.startsWith(level1 + '.'));
                    const siblingsL1 = treeData.permissions.filter(p => p.startsWith(level1 + '.'));
                    const cleanL2Siblings = Array.from(new Set(siblingsL1.map(child => child.split('.').slice(0, 3).join('.'))));
                    if (cleanL2Siblings.length === cleanDataCheckL1.length && cleanL2Siblings.sort().every((item, index) => item === cleanDataCheckL1.sort()[index])) {
                        const newCleanDataCheck = newDataCheck.filter(p => !p.startsWith(level1 + '.'));
                        newDataCheck = [...newCleanDataCheck, level1];
                    }

                    const cleanDataCheckL0 = newDataCheck.filter(p => p.startsWith(level0 + '.'));
                    const siblingsL0 = treeData.permissions.filter(p => p.startsWith(level0 + '.'));
                    const cleanL1Siblings = Array.from(new Set(siblingsL0.map(child => child.split('.').slice(0, 2).join('.'))));
                    if (cleanL1Siblings.length === cleanDataCheckL0.length && cleanL1Siblings.sort().every((item, index) => item === cleanDataCheckL0.sort()[index])) {
                        const newCleanDataCheck = newDataCheck.filter(p => !p.startsWith(level0 + '.'));
                        newDataCheck = [...newCleanDataCheck, level0];
                    }

                    setDataCheck(newDataCheck);
                    finalCheck = newDataCheck;
                }
            }
        } else {
            setDataCheck(effective);
            finalCheck = effective;
        }

        if (finalCheck != null) {
            const allElementsExist = siblings.every(element => finalCheck.includes(element));
            if (allElementsExist) {
                const parent = siblings[0].split('.').slice(0, 3).join('.');
                const updateDataCheck = finalCheck.map(item => siblings.includes(item) ? parent : item);
                const FinalData = Array.from(new Set(updateDataCheck));
                setDataCheck(FinalData);
            }
        }
    };

    useEffect(() => {
        if (dataCheck) {
            onChange(dataCheck , 'permissions', checkTree);
        }
    }, [dataCheck]);

    let categories = [];
    if (treeData !== null) {
        categories = Array.from(
        new Set(
            treeData.permissions.map(perm => {
                const parts = perm.split('.');
                return parts.length > 1 ? parts[0] : perm;
            })
        ));
    }

    return (
        <div>
            {categories.map((category, index) => {
                const hasChildren = treeData.permissions.some(perm => perm.startsWith(category + '.'));
                const children = treeData.permissions.filter(perm => perm.startsWith(category + '.'));
                
                const groupedChildren = Array.from(
                    new Set(children.map(child => child.split('.').slice(0, 2).join('.')))
                );

                const isDisabled = !isAvailable(category);
                return (
                    <div key={category}>
                        {hasChildren ? (
                            <span onClick={() => toggleCategory(category)} style={{ cursor: 'pointer', marginRight: 8 }}>
                                {expandedCategories[category] ? <i className="bx bx-chevron-down" /> : <i className="bx bx-chevron-right" />}
                            </span>
                        ) : (
                            <span style={{ marginRight: 24 }}></span>
                        )}
                        <label style={{ opacity: isDisabled ? 0.5 : 1, cursor: isDisabled ? 'not-allowed' : 'auto' }}>
                            <input
                                type="checkbox"
                                checked={isEffectivelyChecked(category)}
                                onChange={() => handleParentChange(category)}
                                className="me-2"
                                disabled={isDisabled}
                            />
                            {category}
                        </label>
                        {expandedCategories[category] && hasChildren && (
                            <div style={{ marginLeft: 25 }}>
                                {groupedChildren.map((child, index) => {
                                    const allSubChildren = children.filter(perm => perm.startsWith(child + '.'));
                                    const isChildDisabled = !isAvailable(child);

                                    const groupedThirdChildren = Array.from(
                                        new Set(allSubChildren.map(subChild => {
                                            const parts = subChild.split('.');
                                            return parts.length >= 3 ? parts.slice(0, 3).join('.') : subChild;
                                        }))
                                    );

                                    return (
                                        <div key={index}>
                                            {groupedThirdChildren.length > 0 ? (
                                                <span onClick={() => toggleSecondChildren(child)} style={{ cursor: 'pointer', marginRight: 8 }}>
                                                    {expandedSecondChildren[child] ? <i className="bx bx-chevron-down" /> : <i className="bx bx-chevron-right" />}
                                                </span>
                                            ) : (
                                                <span style={{ marginRight: 24 }}></span>
                                            )}
                                            <label style={{ opacity: isChildDisabled ? 0.5 : 1, cursor: isChildDisabled ? 'not-allowed' : 'auto' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={isEffectivelyChecked(child)}
                                                    onChange={() => handleChildChange(child)}
                                                    className="me-2"
                                                    disabled={isChildDisabled}
                                                />
                                                {child.split('.')[1]}
                                            </label>

                                            {expandedSecondChildren[child] && groupedThirdChildren.length > 0 && (
                                                <div style={{ marginLeft: 45 }}>
                                                    {groupedThirdChildren.map(thirdChild => {
                                                        const fourthChildren = treeData.permissions.filter(perm => perm.startsWith(thirdChild + '.') && perm.split('.').length > 3);
                                                        const hasFourth = fourthChildren.length > 0;
                                                        const isThirdDisabled = !isAvailable(thirdChild);
                                                        
                                                        return (
                                                            <div key={thirdChild}>
                                                                {hasFourth ? (
                                                                    <span onClick={() => toggleThirdChildren(thirdChild)} style={{ cursor: 'pointer', marginRight: 8 }}>
                                                                        {expandedThirdChildren[thirdChild] ? <i className="bx bx-chevron-down" /> : <i className="bx bx-chevron-right" />}
                                                                    </span>
                                                                ) : (
                                                                    <span style={{ marginRight: 24 }}></span>
                                                                )}
                                                                <label style={{ opacity: isThirdDisabled ? 0.5 : 1, cursor: isThirdDisabled ? 'not-allowed' : 'auto' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={isEffectivelyChecked(thirdChild)}
                                                                        onChange={() => handleThirdChildChange(thirdChild)}
                                                                        className="me-2"
                                                                        disabled={isThirdDisabled}
                                                                    />
                                                                    {thirdChild.split('.')[2]}
                                                                </label>

                                                                {expandedThirdChildren[thirdChild] && hasFourth && (
                                                                    <div style={{ marginLeft: 45 }}>
                                                                        {fourthChildren.map(fourthChild => {
                                                                            const isFourthDisabled = !isAvailable(fourthChild);
                                                                            return (
                                                                                <div key={fourthChild}>
                                                                                    <span style={{ marginRight: 24 }}></span>
                                                                                    <label style={{ opacity: isFourthDisabled ? 0.5 : 1, cursor: isFourthDisabled ? 'not-allowed' : 'auto' }}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={isEffectivelyChecked(fourthChild)}
                                                                                            onChange={() => handleFourthChildChange(fourthChild)}
                                                                                            className="me-2"
                                                                                            disabled={isFourthDisabled}
                                                                                        />
                                                                                        {fourthChild.split('.')[3]}
                                                                                    </label>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}